export default {
  newPreset: 'New preset',
};
